
<div>
	<v-card v-if="userisconfirmed" class="mx-auto elevation-1" style="max-width: 500px" :loading="apiRequest">
		<v-card-title class="pa-5 text-center headline font-weight-black">
			<v-spacer />Sign In
			<v-spacer />
		</v-card-title>
		<v-card-subtitle v-if="loginerror" class="text-center red--text">Error Logging in. Please check your username/password.</v-card-subtitle>
		<v-card-text v-if="!newPasswordRequired">
			<v-form ref="signinform" v-model="valid" lazy-validation>
				<v-text-field v-model="email" label="E-mail" type="text" outlined :rules="emailRules" required />
				<v-text-field
					id="password"
					v-model="password"
					:append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'"
					:type="showpassword ? 'text' : 'password'"
					name="password"
					label="Password"
					:counter="password.length > 0"
					outlined
					:rules="passwordRules"
					required
					@click:append="showpassword = !showpassword"
				/>
			</v-form>
		</v-card-text>
		<v-card-text v-if="newPasswordRequired">
			<v-form ref="signinform" v-model="valid" lazy-validation>
				<v-text-field v-model="email" label="E-mail" type="text" outlined :rules="emailRules" required />
				<v-text-field
					id="password"
					v-model="password"
					label="Password"
					outlined
					:type="showpassword ? 'text' : 'password'"
					:append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'"
					required
					name="password"
					:rules="passwordRules"
					@click:append="showpassword = !showpassword"
				></v-text-field>

				<v-card-subtitle class="text-center red--text">You are using a temporary password. Please provide your new password and click sign in.</v-card-subtitle>

				<v-text-field
					id="confirmpassword"
					v-model="confirmpassword"
					label="New Password"
					:rules="[...passwordRules, passwordConfirmationRule]"
					outlined
					:type="showpassword ? 'text' : 'password'"
					:append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'"
					name="confirmpassword"
					required
					@click:append="showpassword = !showpassword"
				></v-text-field>
			</v-form>
		</v-card-text>
		<v-card-actions>
			<v-spacer />
			<v-btn class="mb-2 pa-1 text-none" :loading="apiRequest" :disabled="!valid" width="200px" x-large rounded color="primary" @click="signIn"
				>Sign In
				<!-- <v-icon right>mdi-arrow-right</v-icon> -->
			</v-btn>

			<v-spacer />
		</v-card-actions>
	</v-card>

	<!--user-confirm-signup-form v-if="!userisconfirmed"></user-confirm-signup-form-->
	<!-- end confirm signup form -->
</div>
